import { createSlice } from "@reduxjs/toolkit";

interface MenuState {
  isActive: boolean;
}

const initialState: MenuState = {
  isActive: JSON.parse(localStorage.getItem("menuState") || "true"),
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    toggleMenu: (state: MenuState) => {
      state.isActive = !state.isActive;
      localStorage.setItem("menuState", JSON.stringify(state.isActive));
    },
  },
});

export const { toggleMenu } = menuSlice.actions;
export default menuSlice.reducer;
